import http from './http'

/**
 * Proxy service for handling CORS issues with external image URLs
 */

/**
 * Fetches an image through a proxy to avoid CORS issues
 * @param {string} imageUrl - The original image URL
 * @returns {Promise<Blob>} - The image blob
 */
function proxyImage(imageUrl) {
  return http({
    method: 'GET',
    url: '/proxy/image',
    params: {
      url: encodeURIComponent(imageUrl)
    },
    responseType: 'blob'
  })
}

/**
 * Fetches an image and converts it to base64 through proxy
 * @param {string} imageUrl - The original image URL
 * @returns {Promise<string>} - Base64 data URL
 */
async function proxyImageAsBase64(imageUrl) {
  try {
    const response = await proxyImage(imageUrl)
    const blob = response.data
    
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result)
      reader.onerror = () => reject(new Error('Failed to read blob'))
      reader.readAsDataURL(blob)
    })
  } catch (error) {
    console.error('Proxy image fetch failed:', error)
    throw error
  }
}

export default {
  proxyImage,
  proxyImageAsBase64
} 